import styled from "styled-components";
import { Modal } from "components/Modal";

// Checkout-mode: the US-citizen attestation checkbox row (free -> paid).
// Shared dialog shell + typography live in ../shared/ConfirmDialog.styles.
export const AttestationLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
  cursor: pointer;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  line-height: 1.6;
  color: #535862;

  input[type="checkbox"] {
    flex-shrink: 0;
    margin-top: 2px;
    width: 16px;
    height: 16px;
    appearance: auto;
    -webkit-appearance: auto;
    accent-color: #181d27;
    cursor: pointer;
  }
`;

// Order-details mode: paid -> paid upgrade with a proration preview.
export const OrderDetailsContainer = styled(Modal)`
  z-index: 1060;

  &.modal {
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-dialog {
    max-width: 460px;
  }

  .modal-content {
    padding: 24px;
    border-radius: 16px;
    font-family: "Geist", sans-serif;
  }

  .modal-body {
    padding: 0;
    margin: 0;
  }

  .upgrade-title {
    font-size: 20px;
    font-weight: 600;
    color: #181d27;
    margin: 0 0 18px;
    letter-spacing: -0.2px;
  }

  .plan-cards {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
  }

  .plan-card {
    flex: 1;
    border: 1px solid rgba(0, 0, 0, 0.09);
    border-radius: 12px;
    padding: 14px 16px;
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 10px;

    &.selected {
      border: 1px solid rgba(10, 13, 18, 0.24);
      background: #fafafa;
    }

    .plan-card-top {
      min-height: 22px;
    }

    .current-pill {
      display: inline-block;
      font-size: 12px;
      font-weight: 500;
      color: #535862;
      background: #f2f4f7;
      border-radius: 6px;
      padding: 2px 8px;
    }

    .plan-dot {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #181d27;
    }

    .plan-card-name {
      font-size: 15px;
      font-weight: 600;
      color: #181d27;
    }

    .plan-card-price {
      font-size: 13px;
      color: #535862;
    }
  }

  .order-details {
    background: #fafafa;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    padding: 18px;
    margin-bottom: 16px;

    .order-heading {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.2px;
      color: #181d27;
      margin: 0 0 14px;
    }

    .order-row {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: 12px;
      margin-bottom: 12px;

      .order-row-label {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.1px;
        color: #181d27;
      }

      .order-row-desc {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.1px;
        color: #535861;
        margin-top: 2px;
      }

      .order-row-amount {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.1px;
        color: #181d27;
        white-space: nowrap;
      }

      &.total {
        margin-bottom: 0;
        .order-row-label,
        .order-row-amount {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: -0.2px;
        }
      }
    }

    .order-divider {
      height: 1px;
      background: rgba(0, 0, 0, 0.08);
      margin: 4px 0 14px;
    }
  }

  .renewal-note {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    border: 1px solid rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 1.5;
    color: #535862;

    .note-icon {
      flex-shrink: 0;
      margin-top: 1px;
      color: #717680;
    }

    b {
      color: #181d27;
      font-weight: 600;
    }
  }

  .payment-method {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 16px;

    .pm-label {
      font-size: 14px;
      font-weight: 500;
      color: #181d27;
    }

    .pm-right {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #181d27;
    }

    .pm-icon {
      color: #717680;
    }

    .pm-edit {
      background: none;
      border: none;
      padding: 4px;
      cursor: pointer;
      color: #717680;
      display: flex;
      &:hover {
        color: #181d27;
      }
    }
  }

  .agree {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 18px;
    font-size: 12px;
    line-height: 1.6;
    color: #717680;
    cursor: pointer;

    input[type="checkbox"] {
      flex-shrink: 0;
      margin-top: 2px;
      width: 16px;
      height: 16px;
      appearance: auto;
      -webkit-appearance: auto;
      accent-color: #181d27;
      cursor: pointer;
    }
  }

  .upgrade-cta {
    width: 100%;
    min-height: 46px;
    border: none;
    border-radius: 8px;
    background: #181d27;
    color: #fff;
    font-family: "Geist", sans-serif;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background 0.15s ease;

    &:hover:not(:disabled) {
      background: #2d3748;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:has(.cta-loader) {
      opacity: 1;
    }

    .cta-loader {
      width: 18px !important;
      height: 18px !important;
      .loader .spinner-border {
        width: 18px;
        height: 18px;
        border-width: 2px;
        color: #fff;
      }
    }
  }

  .preview-loading {
    display: flex;
    justify-content: center;
    padding: 40px 0;
  }

  .preview-error {
    text-align: center;
    padding: 24px 0;
    font-size: 14px;
    color: #b42318;
  }

  @media (max-width: 520px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;
    }
  }
`;
